import { styled, Box } from "@mui/material";

export const DynamicViewportOverlayRoot = styled(Box)(({ open }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  pointerEvents: "none",
  zIndex: 9,
  opacity: open ? 1 : 0,
  transition: "all 0.3s ease-in-out",
}));
